// [F-COOKIECMP] A React karrieroldal által ténylegesen tárolt sütik és
// böngésző-tárolók leltára a cookie-nyilatkozathoz (CookieConsent részletek nézet).
//
// A lista EMPIRIKUSAN ellenőrzött (Set-Cookie fejlécek + kód-leltár, 2026-08-13):
//  - szerveroldal: system_language, XSRF-TOKEN, system_job_language
//  - React: career_consent_v1, cs_popup_seen + sessionStorage (career_tracking_v1,
//    career_apply_status_v1)
//  - hozzájárulás után, csak ha az admin konfigurálta: Google (_ga, _ga_*),
//    Meta (_fbp, _fbc) és TikTok (_ttp, ttcsid_*, ttclid) sütik
// Az utm_data sütit a LEGACY karrieroldal írja, de a React SSR KIOLVASSA a
// jelentkezés-forrás rögzítéséhez — ezért szerepel a nyilatkozatban.
// A XDEBUG_SESSION dev-környezeti műterméke — élesben nincs, nem szerepel.
//
// A szövegek hu/en párban itt élnek (nem az admin-felülírható resolver-kulcsok
// között), mert a tartalmuk a KÓD tényleges viselkedését dokumentálja — admin
// általi átírásuk félrevezető nyilatkozatot eredményezne.
export const COOKIE_INVENTORY = {
    necessary: [
        {
            name: 'career_consent_v1',
            kind: 'cookie',
            provider: 'site',
            expiry: { hu: '1 év', en: '1 year' },
            description: {
                hu: 'A süti-hozzájárulási döntésed tárolása — ebből tudja az oldal, hogy mely kategóriákhoz járultál hozzá.',
                en: 'Stores your cookie consent decision — this is how the site knows which categories you have consented to.',
            },
        },
        {
            name: 'XSRF-TOKEN',
            kind: 'cookie',
            provider: 'site',
            expiry: { hu: '1 óra', en: '1 hour' },
            description: {
                hu: 'Munkamenet-hitelesítési biztonsági token (JWT), amely a kérések biztonságos azonosítását és a kérés-hamisítás megakadályozását szolgálja.',
                en: 'Session authentication security token (JWT) used to securely identify requests and prevent request forgery.',
            },
        },
        {
            name: 'career_tracking_v1',
            kind: 'storage',
            provider: 'site',
            expiry: { hu: 'böngésző-munkamenet', en: 'browser session' },
            description: {
                hu: 'A jelentkezés forrásának (pl. hirdetési csatorna, ajánló) megjegyzése az oldalon belüli navigáció alatt, hogy a beküldött jelentkezéshez kapcsolható legyen. Az érkező hivatkozás kattintás-azonosítóit (pl. gclid, fbclid) is tartalmazhatja — ezek felhasználása (a jelentkezéshez rögzítés és a hirdetési partner felé történő konverzió-visszajelzés) kizárólag a Célzás kategória elfogadása esetén történik.',
                en: 'Remembers the source of your application (e.g. advertising channel, referrer) during navigation so it can be attached to the submitted application. It may include click identifiers from the incoming link (e.g. gclid, fbclid) — these are only used (recorded with the application and sent as conversion feedback to the advertising partner) if the Targeting category is accepted.',
            },
        },
        {
            name: 'career_apply_status_v1',
            kind: 'storage',
            provider: 'site',
            expiry: { hu: 'böngésző-munkamenet', en: 'browser session' },
            description: {
                hu: 'A jelentkezésed állapotát mutató oldal biztonsági azonosítója.',
                en: 'Security identifier for the page showing the status of your application.',
            },
        },
        {
            name: 'utm_data',
            kind: 'cookie',
            provider: 'site',
            expiry: { hu: '30 perc', en: '30 minutes' },
            description: {
                hu: 'A hirdetési forrás jelölője, ha a látogató a rendszer korábbi típusú oldaláról érkezett — az oldal ezt kiolvassa a jelentkezés forrásának rögzítéséhez.',
                en: 'Marker of the advertising source when the visitor arrives from a legacy page of the system — the site reads it to record the source of the application.',
            },
        },
    ],
    performance: [
        {
            name: '_ga',
            kind: 'cookie',
            provider: 'Google',
            requires: 'ga',
            expiry: { hu: '2 év', en: '2 years' },
            description: {
                hu: 'Google Analytics látogató-azonosító a látogatások és a forgalom statisztikai méréséhez.',
                en: 'Google Analytics visitor identifier used for statistical measurement of visits and traffic.',
            },
        },
        {
            name: '_ga_*',
            kind: 'cookie',
            provider: 'Google',
            requires: 'ga',
            expiry: { hu: '2 év', en: '2 years' },
            description: {
                hu: 'Google Analytics munkamenet-állapot tárolása.',
                en: 'Stores Google Analytics session state.',
            },
        },
    ],
    targeting: [
        {
            name: '_fbp',
            kind: 'cookie',
            provider: 'Meta (Facebook)',
            requires: 'fb',
            expiry: { hu: '3 hónap', en: '3 months' },
            description: {
                hu: 'A Meta (Facebook) Pixel böngésző-azonosítója hirdetések méréséhez és releváns hirdetések megjelenítéséhez.',
                en: 'Meta (Facebook) Pixel browser identifier used for ad measurement and showing relevant ads.',
            },
        },
        {
            name: '_fbc',
            kind: 'cookie',
            provider: 'Meta (Facebook)',
            requires: 'fb',
            expiry: { hu: '3 hónap', en: '3 months' },
            description: {
                hu: 'A Meta (Facebook) hirdetés-kattintás azonosítóját (fbclid) tároló süti, hirdetések eredményességének méréséhez — csak Facebook-hirdetésről érkezéskor jön létre.',
                en: 'Stores the Meta (Facebook) ad click identifier (fbclid) for measuring ad effectiveness — only created when arriving from a Facebook ad.',
            },
        },
        // [F-TIKTOKPIXEL] a TikTok hivatalos süti-listája szerint (13 hónap az utolsó használattól)
        {
            name: '_ttp',
            kind: 'cookie',
            provider: 'TikTok',
            requires: 'tt',
            expiry: { hu: '13 hónap', en: '13 months' },
            description: {
                hu: 'A TikTok Pixel böngésző-azonosítója hirdetési kampányok mérésére és releváns hirdetések megjelenítésére a TikTokon.',
                en: 'TikTok Pixel browser identifier used to measure advertising campaigns and show relevant ads on TikTok.',
            },
        },
        {
            name: 'ttcsid_*',
            kind: 'cookie',
            provider: 'TikTok',
            requires: 'tt',
            expiry: { hu: '13 hónap', en: '13 months' },
            description: {
                hu: 'A TikTok Pixel munkamenet-azonosítója (pixelenként), a hirdetési kampányok eredményességének méréséhez.',
                en: 'TikTok Pixel session identifier (per pixel) used to measure advertising campaign performance.',
            },
        },
        {
            name: 'ttclid',
            kind: 'cookie',
            provider: 'TikTok',
            requires: 'tt',
            expiry: { hu: '13 hónap', en: '13 months' },
            description: {
                hu: 'A TikTok hirdetés-kattintás azonosítóját tároló süti a hirdetések eredményességének méréséhez — csak TikTok-hirdetésről érkezéskor jön létre.',
                en: 'Stores the TikTok ad click identifier for measuring ad effectiveness — only created when arriving from a TikTok ad.',
            },
        },
    ],
    // A nyelvi és felugró-preferencia sütik tematikusan a Funkcionalitás alá
    // tartoznak (Cookie-Script paritás). JOGI HELYZETÜK a kategória-leírásban
    // kimondva: a látogató saját művelete alapján, hozzájárulás nélkül is
    // létrejöhetnek (EDPB 04/2012: a felhasználói felület testreszabási sütijei —
    // pl. nyelvi preferencia — consent-mentesek; a system_language-et a rendszer
    // az alapértelmezett nyelvvel automatikusan is beállítja). A kategória
    // KAPCSOLÓJA a Google Consent Mode functionality_storage/personalization_storage
    // jelzéseit vezérli — a saját preferencia-sütiket nem kapuzza, ezt a leírás
    // őszintén közli.
    functionality: [
        {
            name: 'system_job_language',
            kind: 'cookie',
            provider: 'site',
            expiry: { hu: 'kb. 3 év', en: 'approx. 3 years' },
            description: {
                hu: 'A karrieroldalon általad kiválasztott nyelv megjegyzése, hogy visszatéréskor a saját nyelveden jelenjen meg az oldal.',
                en: 'Remembers the language you selected on the career site so the page appears in your language on return.',
            },
        },
        {
            name: 'system_language',
            kind: 'cookie',
            provider: 'site',
            expiry: { hu: 'kb. 27 év', en: 'approx. 27 years' },
            description: {
                hu: 'A megjelenítési nyelv tárolása — az oldal automatikusan is beállítja az alapértelmezett nyelvvel, nyelvváltáskor pedig a választásodat rögzíti.',
                en: 'Stores the display language — the site also sets it automatically with the default language, and records your choice when you switch languages.',
            },
        },
        {
            name: 'cs_popup_seen',
            kind: 'cookie',
            provider: 'site',
            expiry: { hu: 'legfeljebb 1 év (beállítás szerint)', en: 'up to 1 year (as configured)' },
            description: {
                hu: 'Azt rögzíti, hogy a felugró tájékoztatót bezártad — ha az oldalon aktív ilyen üzenet, nem jelenik meg újra.',
                en: 'Records that you closed the popup message — if such a message is active on the site, it will not appear again.',
            },
        },
    ],
    // Besorolatlan: minden ismert sütink kategorizált — ez a szekció üres, a
    // nyilatkozat teljessége miatt jelenik meg (Cookie-Script paritás). Ha később
    // kerül ide sor, a UI automatikusan megjeleníti.
    unclassified: [],
};
/**
 * Az adott kategóriában megjelenítendő sorok — a mérőkód-függő sorok (GA/Meta)
 * csak akkor szerepelnek, ha az admin ténylegesen konfigurálta az azonosítót.
 */
export function getVisibleRows(category, tracking) {
    return COOKIE_INVENTORY[category].filter((row) => {
        if (row.requires === 'ga')
            return !!(tracking.ga_id && tracking.ga_id !== '');
        if (row.requires === 'fb')
            return !!(tracking.fb_pixel_id && tracking.fb_pixel_id !== '');
        if (row.requires === 'tt')
            return !!(tracking.tiktok_pixel_id && tracking.tiktok_pixel_id !== '');
        return true;
    });
}
